<template>
    <v-container fluid>
        <v-row no-gutters justify="center" align-self="center">
            <v-col id="img-container" justify="center" cols="auto">
                <img src="img/error/server-down.png" />
            </v-col>
        </v-row>

        <v-row class="mt-2" no-gutters justify="center" align-self="center">
            <v-col justify="center" cols="auto">
                <h2 translate>¡Servidor no disponible!</h2>
            </v-col>
        </v-row>

        <v-row class="mt-2" no-gutters justify="center" align-self="center">
            <v-col justify="center" cols="8">
                <p translate>"El servidor de la aplicación no está disponible en estos momentos. Esto puede ser debido a
                    que está temporalmente inaccesible por razones técnicas o tareas de mantenimiento."</p>
                <p translate>"Puede volver a intentarlo más tarde. Disculpe las molestias."</p>
            </v-col>
        </v-row>

        <v-row class="mt-2" no-gutters justify="center" align-self="center">
            <v-col justify="center" cols="auto">
                <v-btn dark rounded @click="$router.go(-1)">
                    <v-icon dark>mdi-refresh</v-icon>
                    <span style="text-indent: 5px">Reintentar</span>
                </v-btn>
            </v-col>
        </v-row>

        <div class="row center-xs col-xs-12">

        </div>

    </v-container>
</template>

<script>

// const props = defineProps({
//     error: Error
// });

export default {
    name: 'server-down-page',
    bodyClass: 'server-down',
    data() {
        return {};
    },
    methods: {
    },
    components: {
    }
};
</script>

<style scoped>
.server-down {
    padding: 0 !important;
}

.server-down .container {
    margin-top: 10% !important;
    padding: 0px;
    padding-bottom: 90%;
    width: 98.79vw;
    height: 50vh;
    justify-content: center;
    align-items: center;
}

#img-container img {
    max-height: 200px;
}

h2 {
    font-size: 5vh;
    color: black;
    line-height: 1.0;
}

p {
    margin-bottom: 10px;
    font-style: italic;
    font-size: 2vh;
    line-height: 1.1;
}
</style>